import React from 'react';
import './Projects.css';
// import { FaGithubSquare } from 'react-icons/fa';
import { FiExternalLink } from 'react-icons/fi';
import "aos/dist/aos.css";

const Project = (props) => {

    const { img, title, liveLink } = props.project;

    return (
        <div className="col mb-5">
            <div className="card h-100 card-style ">
                <div className="screen">
                    <img src={img} className="card-img-top" alt={title} title="Hover on image to see full design!" />
                </div>
                <div className="card-body">
                    <h5 className="card-title">{title}</h5>
                    {/* <p className="card-text">{description}</p> */}
                </div>
                <div className="card-footer">
                    {/* <a href={gitHub}><FaGithubSquare /></a> */}
                    <a href={liveLink}><FiExternalLink /></a>
                </div>
            </div>
        </div>
    );
};

export default Project;